import ApiService from '@/services/common/api.service';
import StorageService from '@/services/common/storage.service';
import { Constants } from "@/helpers/constants";

const TourManagementService = {
    getTour,
};

async function getTour (id = "", isClosed = 0) {
    let url = '/tours/' + id;
    // Remove tour and cash in storage when search tour
    StorageService.removeTour();
    try {
        let response;
        if (isClosed) {
            url += '?isClosed=' + isClosed;
            response = await ApiService.get(url);
        } else {
            response = await ApiService.get(url);
        }
        StorageService.saveTour(JSON.stringify(response.data));
        StorageService.saveTourIdServer(JSON.stringify(response.data.id));
        const boxFolderIdMap = response.data.boxFolderIds;
        StorageService.saveBoxFolderIdMap(JSON.stringify(boxFolderIdMap));
        return response;
    } catch (error) {
        return error;
    }
}

export default TourManagementService;



// WEBPACK FOOTER //
// ./src/services/module/tour.service.js